{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Download (v2)"
      }
    }
  },
  "promotion": {
    "checkedInBaggage": {
      "genericBaggageType": "Baggage",
      "numberedBaggageTitle": "{bagNumber}. {baggageType}",
      "baggageWeight": "{weight} kg"
    }
  },
  "includedProducts": {
    "quotaLeft": {
      "singular": "Only one left",
      "plural": "Only {quota} left"
    }
  }
}
